<template>
  <div id="chat" class="chat" :class="titleShow ? '' : 'isShow'">
    <div class="nav">
      <p>请你留言</p>
      <div class="button-style" @click="isShow">
        <img v-if="titleShow" src="./images/down.png" alt="" />
        <img v-else src="./images/upward.png" alt="" />
      </div>
    </div>
    <div class="cont">
      <div class="cont-title">
        <h2>中税税务</h2>
        <p>12345678900</p>
      </div>
      <div class="textarea-style">
        <textarea name id cols="30" rows="10" placeholder="请在此输入留言内容，我们会尽快与你联系。（必填）" v-model="messageDetails"></textarea>
      </div>
      <div class="name comm">
        <img src="./images/nickname.png" alt="">
        <input type="text" placeholder="姓名（必填）" v-model="name" />
      </div>
      <div class="phone comm">
        <img src="./images/phone.png" alt="">
        <input
          id="mobile"
          type="text"
          onkeyup="value=value.replace(/[^\d]/g,'')"
          maxlength="11"
          placeholder="电话（必填）"
          v-model="phone"
        />
      </div>
      <div class="map comm">
        <img src="./images/togo.png" alt="">
        <input type="text" placeholder="地址" v-model="address" />
      </div>
      <div class="sumbit" @click="sumbit">发送</div>
    </div>
  </div>
</template>

<script>
import request from "@/network/request.js";
export default {
  name: "chat",
  data() {
    return {
      titleShow: false,
      messageDetails: '',  // 详细信息 必选
      address: '', // 地址 可选
      name: '', // 名字
      phone: '' // 手机
    };
  },
  methods: {
    isShow() {
      this.titleShow = !this.titleShow;
    },
    sumbit() {
      let {name, phone, address, messageDetails} = this.$data
      if (!messageDetails) {
        alert('请填写内容')
        return;
      }else if(!name) {
        alert('请填写姓名')
        return;
      }else if(!phone) {
        alert('请填写手机')
        return;
      }
      console.log('name', name,'phone', phone,'address', address,'messageDetails', messageDetails)
      request({
        url: "/zhongshui/message/insert",
        method: "post",
        data: {
          name: name,
          phone: phone,
          address: address,
          messageDetails: messageDetails
        }
      })
        .then(res => {
          console.log(res);
          let data = res.data;
          this.name = ''
          this.phone = ''
          this.messageDetails = ''
          this.address = ''
        })
        .catch(err => {
          console.log("请求错误", this.name);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.isShow {
  transform: translate(0px, 370px);
}
input {
  background: none;
  outline: none;
  border: none;
  height: 100%;
  width: 100%;
}
.chat {
  width: 250px;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 500;
  transition: all 0.4s;
  .nav {
    background: rgb(24, 106, 201);
    height: 40px;
    border-radius: 10px 0 0 0;
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding-right: 20px;
    justify-content: space-between;
    p {
      font-size: 15px;
      color: white;
    }
    .button-style {
      width: 32px;
      // height: px;
      // border-radius: 2.5px;
      // background-color: white;
      color: white;
      font-size: 32px;
      img {
        width: 100%;
      }
    }
  }
  .cont {
    height: 370px;
    background-color: rgb(212, 212, 212);
    .cont-title {
      padding-left: 15px;
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid rgb(189, 189, 189);
      h2 {
        font-weight: 400;
        color: rgb(107, 107, 107);
      }
      p {
        color: rgb(92, 92, 92);
      }
    }
    .textarea-style {
      padding-top: 15px;
      padding-left: 15px;
      textarea {
        resize: none;
        height: 80px;
        width: 220px;
      }
    }
    .comm {
      img {
        height: 80%;
      }
    }
    .name {
      height: 30px;
      margin-top: 15px;
      margin-left: 15px;
      margin-right: 15px;
      border: 1px solid #cccccc;
      display: flex;
      align-items: center;
      background: white;
    }
    .phone {
      height: 30px;
      margin-top: 15px;
      margin-left: 15px;
      margin-right: 15px;
      border: 1px solid #cccccc;
      display: flex;
      align-items: center;
      background: white;
    }
    .map {
      height: 30px;
      margin-top: 15px;
      margin-left: 15px;
      margin-right: 15px;
      border: 1px solid #cccccc;
      display: flex;
      align-items: center;
      background: white;
    }
    .sumbit {
      margin: 15px;
      margin-left: 15px;
      width: 80px;
      height: 35px;
      background: rgb(26, 135, 224);
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/common/chat-case.vue